<template>
	<a v-bind:href="url" v-on:click.prevent.stop="handleClick" class="common-nav-link" :disabled="disabled">
		<slot>LINK</slot>
	</a>
</template>

<script>
export default {
	name: 'NavLink',
	props: {
		url: {
			type: String,
		},
		openUrl: {
			type: Boolean,
			default: false,
		},
		externalUrl: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		click: {},
	},
	methods: {
		handleClick: function(e) {
			if (this.click) {
				this.click(e);
			} else {
				if (this.disabled) {
					return;
				}

				if (!this.openUrl) {
					this.$device.pushView(this.url, this.externalUrl);
				} else if (this.openUrl) {
					this.$device.openUrl(this.url, this.externalUrl);
				}
			}
		},
	},
};
</script>

<style scoped></style>
